import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FlightOrderCard from "./FlightOrderCard/FlightOrderCard";
import "../index.css";

function GoFlySmartFlightOrderCard({ order, ...props }) {
  const { flight_data } = order;
  function createUTCdateForISO(dateString) {
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();

    return dateAsISO;
  }
  const addSeconds = (DateValue, TimeValue) => {
    if (TimeValue.split(":").length<3) {
      TimeValue = TimeValue + ":00"
    }
    return DateValue+"T"+TimeValue+".000Z"
  }
  const flightOrder = {
    status: order?.status?.toUpperCase(),
    order_amount: order?.order_amount,
    amount: order?.amount,
    currency: order?.vendorDetails?.at(0)?.currency || "INR",
    booking_id: order?.booking_id,
    vendorDetails: order?.vendorDetails.at(0),
    createdAt: order?.createdAt,
    updatedAt: order?.updatedAt,
    flight_data: flight_data && {
      origin: flight_data?.destination?.origin?.code,
      destination: flight_data?.destination?.destination?.code,
      segments: [
        {
          airline: flight_data?.airline.code,
          local_departure:
            flight_data.travel_date &&
            flight_data.departure_time &&
            addSeconds(flight_data.travel_date, flight_data.departure_time),
          utc_departure:
            flight_data.travel_date &&
            flight_data.departure_time &&
            addSeconds(flight_data.travel_date, flight_data.departure_time),
          local_arrival:
            flight_data.arrival_date &&
            flight_data.arrival_time &&
            addSeconds(flight_data.arrival_date, flight_data.arrival_time),
          utc_arrival:
            flight_data.arrival_date &&
            flight_data.arrival_time &&
            addSeconds(flight_data.arrival_date, flight_data.arrival_time),
          flyFrom: flight_data?.destination?.origin?.code,
          flyTo: flight_data?.destination?.destination?.code,
          fare_category: "M",
          flight_no: flight_data?.flight_no?.split(" ")?.at(-1),
        },
      ],
    },
    passenger_data: [
      ...(order?.adult_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
      ...(order?.child_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
      ...(order?.infant_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category
      })) || []),
    ],
  };

  return <FlightOrderCard props={props} order={flightOrder} />;
}
export default GoFlySmartFlightOrderCard;
